import type { Locale } from '../i18n';

type ApiErrorPayload = {
  error?: { code?: unknown; params?: unknown; request_id?: unknown };
  detail?: unknown;
};

/**
 * UI copy is owned by the frontend locale. Backend/provider messages are
 * intentionally ignored; callers supply a localized, action-specific fallback.
 */
export const apiErrorMessage = (data: ApiErrorPayload | null | undefined, fallback: string): string => {
  void data;
  return fallback;
};

export const apiErrorCode = (data: ApiErrorPayload | null | undefined): string | null =>
  typeof data?.error?.code === 'string' ? data.error.code : null;

const statusCopy: Record<Locale, Record<string, string>> = {
  en: { queued:'Queued', processing:'Processing', completed:'Completed', partial:'Partially completed', failed:'Failed', ready:'Ready', expired:'Expired' },
  id: { queued:'Dalam antrean', processing:'Diproses', completed:'Selesai', partial:'Selesai sebagian', failed:'Gagal', ready:'Siap', expired:'Kedaluwarsa' },
  es: { queued:'En cola', processing:'Procesando', completed:'Completado', partial:'Completado parcialmente', failed:'Fallido', ready:'Listo', expired:'Caducado' },
  'pt-br': { queued:'Na fila', processing:'Processando', completed:'Concluído', partial:'Concluído parcialmente', failed:'Falhou', ready:'Pronto', expired:'Expirado' },
  ru: { queued:'В очереди', processing:'Обработка', completed:'Завершено', partial:'Завершено частично', failed:'Ошибка', ready:'Готово', expired:'Истёк' },
  tr: { queued:'Sırada', processing:'İşleniyor', completed:'Tamamlandı', partial:'Kısmen tamamlandı', failed:'Başarısız', ready:'Hazır', expired:'Süresi doldu' },
  vi: { queued:'Đang chờ', processing:'Đang xử lý', completed:'Hoàn tất', partial:'Hoàn tất một phần', failed:'Thất bại', ready:'Sẵn sàng', expired:'Đã hết hạn' },
  th: { queued:'อยู่ในคิว', processing:'กำลังประมวลผล', completed:'เสร็จสิ้น', partial:'เสร็จสิ้นบางส่วน', failed:'ล้มเหลว', ready:'พร้อม', expired:'หมดอายุ' },
  ar: { queued:'في قائمة الانتظار', processing:'قيد المعالجة', completed:'مكتمل', partial:'مكتمل جزئيًا', failed:'فشل', ready:'جاهز', expired:'منتهي الصلاحية' },
  'zh-cn': { queued:'排队中', processing:'处理中', completed:'已完成', partial:'部分完成', failed:'失败', ready:'就绪', expired:'已过期' },
  ja: { queued:'待機中', processing:'処理中', completed:'完了', partial:'一部完了', failed:'失敗', ready:'準備完了', expired:'期限切れ' },
  ko: { queued:'대기 중', processing:'처리 중', completed:'완료', partial:'일부 완료', failed:'실패', ready:'준비됨', expired:'만료됨' },
};

export const localizedStatus = (status: unknown, locale: Locale): string => {
  const key = String(status || '').toLowerCase();
  return statusCopy[locale]?.[key] || statusCopy.en[key] || statusCopy[locale].failed;
};
